import {
  jb_svg_css_default
} from "./chunk.35S4IAT4.js";
import {
  ae
} from "./chunk.6PQ7B7BC.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.IIVCI7D3.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass,
  __glob
} from "./chunk.2QRLEY22.js";

// import("./icons/**/*.svg.ts") in src/components/jb-svg/jb-svg.ts
var globImport_icons_svg_ts = __glob({
  "./icons/ARROW_DOWN.svg.ts": () => import("../components/jb-svg/icons/ARROW_DOWN.svg.js"),
  "./icons/ARROW_LEFT.svg.ts": () => import("../components/jb-svg/icons/ARROW_LEFT.svg.js"),
  "./icons/ARROW_RIGHT.svg.ts": () => import("../components/jb-svg/icons/ARROW_RIGHT.svg.js"),
  "./icons/ARROW_UP.svg.ts": () => import("../components/jb-svg/icons/ARROW_UP.svg.js"),
  "./icons/CHEVRON.svg.ts": () => import("../components/jb-svg/icons/CHEVRON.svg.js"),
  "./icons/DOWNLOAD.svg.ts": () => import("../components/jb-svg/icons/DOWNLOAD.svg.js"),
  "./icons/EMAIL_TEMPLATE.svg.ts": () => import("../components/jb-svg/icons/EMAIL_TEMPLATE.svg.js"),
  "./icons/EXTERNAL.svg.ts": () => import("../components/jb-svg/icons/EXTERNAL.svg.js"),
  "./icons/FILE.svg.ts": () => import("../components/jb-svg/icons/FILE.svg.js"),
  "./icons/FILE_EXCEL.svg.ts": () => import("../components/jb-svg/icons/FILE_EXCEL.svg.js"),
  "./icons/FILE_PDF.svg.ts": () => import("../components/jb-svg/icons/FILE_PDF.svg.js"),
  "./icons/FILE_POWERPOINT.svg.ts": () => import("../components/jb-svg/icons/FILE_POWERPOINT.svg.js"),
  "./icons/FILE_WORD.svg.ts": () => import("../components/jb-svg/icons/FILE_WORD.svg.js"),
  "./icons/INTERNAL.svg.ts": () => import("../components/jb-svg/icons/INTERNAL.svg.js"),
  "./icons/IN_PAGE.svg.ts": () => import("../components/jb-svg/icons/IN_PAGE.svg.js"),
  "./icons/MAIL.svg.ts": () => import("../components/jb-svg/icons/MAIL.svg.js"),
  "./icons/NEWS.svg.ts": () => import("../components/jb-svg/icons/NEWS.svg.js"),
  "./icons/POLICIES.svg.ts": () => import("../components/jb-svg/icons/POLICIES.svg.js"),
  "./icons/SHAREPOINT_PAGE.svg.ts": () => import("../components/jb-svg/icons/SHAREPOINT_PAGE.svg.js"),
  "./icons/WEB_PAGE.svg.ts": () => import("../components/jb-svg/icons/WEB_PAGE.svg.js")
});

// src/components/jb-svg/jb-svg.ts
var JbSVG = class extends Icon(r) {
  constructor() {
    super(...arguments);
    this.animation = "NONE";
    this.flexDirection = "row";
    this.hovered = false;
    this._loadedSVG = "";
  }
  connectedCallback() {
    super.connectedCallback();
    this._loadSVG();
  }
  shouldUpdate(changedProperties) {
    if (changedProperties.has("path") || changedProperties.has("icon")) this._loadSVG();
    return super.shouldUpdate(changedProperties);
  }
  /** Returns for example arrow_right from "/icons/ARROW_RIGHT.svg"  */
  _getIconNameFromPath() {
    return this.path?.split("/").pop().replace(".svg", "").toLowerCase() || "";
  }
  /** Sets _loadedSVG by fetching the svg from a given path or icon name */
  _loadSVG() {
    const handle = async () => {
      if (this.path)
        this._loadedSVG = await fetch(this.path).then((res) => res.text()).then((res) => ae(res));
      else if (this.icon) this._loadedSVG = await globImport_icons_svg_ts(`./icons/${this.icon}.svg.ts`).then((res) => res.default);
      else throw new Error("No path or icon provided");
    };
    const promise = new Promise((resolve) => {
      handle().then(() => {
        resolve({ status: "success", svg: this._loadedSVG, path: this.path, icon: this.icon });
      }).catch((error) => {
        resolve({ status: "error", error, path: this.path, icon: this.icon });
      });
    });
    this.dispatchEvent(new CustomEvent("svg-loading", { detail: promise }));
  }
  render() {
    return ke`
      <div
        part="svg"
        class="${Rt({
      [this._getIconNameFromPath()]: true,
      [this.animation?.toLowerCase()]: !!this.animation,
      hovered: this.hovered,
      [this.flexDirection]: true
    })}"
      >
        <!-- Render the svg once it's loaded -->
        ${this._loadedSVG && this._loadedSVG}

        <!-- A slot, that can also be set via property "text" -->
        ${this.text ? ke`<span>${this.text}</span>` : ke`<slot></slot>`}
      </div>
    `;
  }
};
JbSVG.styles = [reset_css_default, jb_svg_css_default];
__decorateClass([
  n()
], JbSVG.prototype, "animation", 2);
__decorateClass([
  n()
], JbSVG.prototype, "flexDirection", 2);
__decorateClass([
  n({ type: Boolean })
], JbSVG.prototype, "hovered", 2);
__decorateClass([
  n()
], JbSVG.prototype, "icon", 2);
__decorateClass([
  n()
], JbSVG.prototype, "path", 2);
__decorateClass([
  n()
], JbSVG.prototype, "text", 2);
__decorateClass([
  r2()
], JbSVG.prototype, "_loadedSVG", 2);
JbSVG = __decorateClass([
  customElement("jb-svg")
], JbSVG);

export {
  JbSVG
};
